module.exports = __webpack_public_path__ + "static/enterprise-0e392f9dad85561f824c6da50be4b9f1.svg";